import RegionalLayout from "./RegionalLayout";
import { Heart } from "lucide-react";

const crd = {
  background: "var(--surface-card)",
  border: "var(--border-width, 1px) solid var(--border-default)",
  borderRadius: "1rem",
  boxShadow: "var(--shadow-card)",
};
const tp = { color: "var(--text-primary)" };
const ts = { color: "var(--text-secondary)" };

export default function ICareCollaboration() {
  return (
    <RegionalLayout>
      <div className="max-w-[1440px] mx-auto space-y-5">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight" style={tp}>ICARE & Collaboration</h1>
          <p className="text-sm mt-0.5" style={ts}>Sagicor core values alignment and collaboration health indicators</p>
        </div>
        <div className="p-12 flex flex-col items-center text-center" style={crd} data-testid="icare-coming-soon">
          <div className="w-16 h-16 rounded-full flex items-center justify-center mb-4" style={{ background: "rgba(236,72,153,0.08)" }}>
            <Heart className="w-8 h-8" style={{ color: "#ec4899" }} />
          </div>
          <p className="text-lg font-semibold" style={tp}>Coming Soon</p>
          <p className="text-sm mt-2 max-w-md" style={ts}>
            Regional averages across ICARE dimensions — Integrity, Customer Focus, Accountability,
            Respect, and Excellence — with collaboration patterns and cross-team engagement.
          </p>
          <div className="flex gap-2 mt-5">
            {["Integrity", "Customer Focus", "Accountability", "Respect", "Excellence"].map(d => (
              <span key={d} className="text-[10px] px-2.5 py-1 rounded-full font-medium"
                style={{ background: "var(--surface-inner)", color: "var(--text-secondary)" }}>{d}</span>
            ))}
          </div>
        </div>
      </div>
    </RegionalLayout>
  );
}
